export default (state = {}, action) => {
  switch (action.type) {
    case "VERSIONS/PUSH": {
      const { newVersion } = action.payload;
      const { sections, currentIndex } = state;
      const currentVersion = sections[currentIndex];
      if(currentVersion === newVersion) return state;
      sections.splice(currentIndex + 1, sections.length - currentIndex);
      sections.push(newVersion);
      return {
        ...state,
        sections: sections,
        currentIndex: currentIndex + 1
      };
    }
    case "VERSIONS/UNDO": {
      const currentIndex = state.currentIndex - 1;
      return {...state, currentIndex: currentIndex};
    }
    case "VERSIONS/REDO": {
      const currentIndex = state.currentIndex + 1;
      return {...state, currentIndex: currentIndex};
    }
    default: {
      return state;
    }
  }
};
